import { PlayerRole, WeaponRole } from '@/types/weapon'

export const weaponNamesEn = {
  nameless_sword: 'Nameless Sword',
  nameless_spear: 'Nameless Spear',
  strategic_sword: 'Strategic Sword',
  heavenquaker_spear: 'Heavenquaker Spear',
  thundercry_blade: 'Thundercry Blade',
  stormbreaker_spear: 'Stormbreaker Spear',
  phalanxbane_blade: 'Phalanxbane Blade',
  snowparting_blade: 'Snowparting Blade',
  panacea_fan: 'Panacea Fan',
  inkwell_fan: 'Inkwell Fan',
  soulshade_umbrella: 'Soulshade Umbrella',
  vernal_umbrella: 'Vernal Umbrella',
  everspring_umbrella: 'Everspring Umbrella',
  infernal_twinblades: 'Infernal Twinblades',
  mortal_rope_dart: 'Mortal Rope Dart',
  unfettered_rope_dart: 'Unfettered Rope Dart',
  skygrasp_rope_dart: 'Skygrasp Rope Dart',
  heavenwill_gauntlets: 'Heavenwill Gauntlets',
  skystrike_gauntlets: 'Skystrike Gauntlets',
  riven_twinblades: 'Riven Twinblades',
  museflow_waist_drum: 'Museflow Waist Drum',
  willowbend_fan: 'Willowbend Fan',
}

export const weaponsEn = {
  names: weaponNamesEn,
  roles: {
    weapon: {
      [WeaponRole.Tank]: 'Tank',
      [WeaponRole.Dps]: 'DPS',
      [WeaponRole.Heal]: 'Healer',
    },
    player: {
      [PlayerRole.Tank]: 'Tank',
      [PlayerRole.Dps]: 'DPS',
      [PlayerRole.Hybrid]: 'Hybrid',
      [PlayerRole.Heal]: 'Healer',
    },
    total: 'Total',
  },
  picker: {
    chooseWeapon: 'Choose a weapon',
    noWeaponsAvailable: 'No weapons available',
    selectWeapon: (weaponName: string, roleLabel: string) => `Select ${weaponName} (${roleLabel})`,
    unavailableSuffix: ' — unavailable, already in the other slot',
    weaponTitle: (weaponName: string, roleLabel: string) => `${weaponName} · ${roleLabel}`,
  },
  controller: {
    chooseFirstBuildWeapon: 'Choose first build weapon',
    chooseSecondBuildWeapon: 'Choose second build weapon',
    chooseFirstGuildBuildWeapon: 'Choose first guild build weapon',
    chooseSecondGuildBuildWeapon: 'Choose second guild build weapon',
    addAltWeapon: 'Add alt weapon',
  },
  slot: {
    chooseBuild: 'Choose a build',
    chooseSavedBuild: 'Choose saved build',
  },
  builds: {
    chooserHint: 'Choose a player or guild loadout',
    savedBuilds: 'Saved builds',
    playerBuilds: 'Player builds',
    guildBuilds: 'Guild builds',
    buildLabel: (number: number) => `Build ${String(number)}`,
    guildBuildLabel: (number: number) => `Guild build ${String(number)}`,
    defaultLabel: 'Default',
    activeLabel: 'Active',
    requiresDistinctWeapons: 'Needs 2 distinct weapons',
    noWeaponsSelected: 'No weapons selected',
    activeBuildTitle: (summary: string) => `Active build — ${summary}`,
    useBuildTitle: (number: number, summary: string) => `Use build ${String(number)} — ${summary}`,
    unavailableBuildTitle: (number: number, summary: string) => `Saved build ${String(number)} — unavailable: requires two distinct weapons — ${summary}`,
    savedBuildTitle: (number: number, summary: string) => `Saved build ${String(number)} — ${summary}`,
    useGuildBuildTitle: (summary: string) => `Use guild build — ${summary}`,
    makeDefault: 'Make default',
    noSavedBuilds: 'No saved builds yet.',
    createBuild: '+ Create build',
    liveBuildAuthorization: 'Only this player or a guild officer can choose a live build.',
    hideAvailableBuilds: 'Hide available builds',
    assignMoreBuilds: 'Assign more builds',
    availableToAssign: 'Available to assign',
    noAssignedGuildBuilds: 'No guild builds assigned to this player yet.',
    noGuildBuilds: 'No guild builds for this player yet.',
    saveCurrentLoadoutAsPersonalBuild: '+ Save as personal build',
    saveCurrentLoadout: '+ Save current loadout',
    createGuildBuild: '+ Create guild build',
    notAssigned: 'Not assigned',
    assignToPlayer: 'Assign to player',
    editFirst: 'Edit first',
    editSecond: 'Edit second',
    remove: 'Remove',
  },
  stats: {
    triggerLabel: (roomName: string) => `Weapon stats for ${roomName}`,
    dialogLabel: 'Weapon stats for this room',
    closeLabel: 'Close weapon stats',
    players: 'players',
    unlimited: 'Unlimited',
    loadout: 'Weapon loadout',
    totalCount: (count: number) => `${String(count)} total`,
    noWeaponsAssigned: 'No weapons assigned',
  },
}
